import { API_BASE_URL, ApiEnvelope, MediaTicket, MusicScanResult, ThumbnailItem, apiClient, authHeaders } from 'service/apiClient';

const audioPlayerApi = {
  createMediaTicket(path: string) {
    return apiClient.post<ApiEnvelope<MediaTicket>>('/api/files/media-ticket', { path }, authHeaders());
  },

  revokeMediaTicket(ticket: string) {
    return apiClient
      .delete('/api/files/media-ticket', { params: { ticket }, ...authHeaders() })
      .catch(() => undefined);
  },

  scanMusic(paths: string[]) {
    return apiClient.post<ApiEnvelope<MusicScanResult>>(
      '/ds/scan-music',
      { paths },
      { ...authHeaders(), timeout: 0 }
    );
  },

  fetchThumbnails(paths: string[], signal?: AbortSignal) {
    return apiClient
      .post<{ items: ThumbnailItem[] }>(
        '/api/files/thumbnails',
        { paths },
        { ...authHeaders(), signal }
      )
      .then((res) => res.data);
  },

  filesStreamUrl(ticket: string) {
    return `${API_BASE_URL}/api/files/stream?${new URLSearchParams({ ticket })}`;
  },
};

export default audioPlayerApi;
